const DUMMY_GET_DATA = "DUMMY_GET_DATA"
const DUMMY_GET_DATA_SUCCESS = "DUMMY_GET_DATA_SUCCESS"

export default (state={dummyData:[]}, action) => {
  switch (action.type) {
    case DUMMY_GET_DATA:
      return {
        ...state
      }
    case DUMMY_GET_DATA_SUCCESS:
      return {
        ...state,
        dummyData:action.payload
      }
  
    default:
      return {
        ...state
      }
  }
}